import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'audiences'
const verb = 'get'

export default class OspreyAudienceMetadata extends BaseAction {
    constructor() {
        const id = '8e6c8022-dae6-43ea-9e2a-348479eac972'
        const path = `/${resource}/metadata`
        super(resource, verb, path, id)
        this.noCache = false
    }

    getMetadata(fields) {
        if (!fields) {
            fields = ['base', 'audience']
        }

        if (Array.isArray(fields)) {
            fields = fields.join(',')
        }

        this.params = {
            fields
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/audiences/audience-metadata.js